(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RaceQuestionController', RaceQuestionController);

    RaceQuestionController.$inject = ['RaceQuestion'];

    function RaceQuestionController(RaceQuestion) {

        var vm = this;

        vm.raceQuestions = [];

        loadAll();

        function loadAll() {
            RaceQuestion.query(function(result) {
                vm.raceQuestions = result;
                vm.searchQuery = null;
            });
        }
    }
})();
